var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_vm._v("\n     "+_vm._s(_vm.title)+"\n     "),(_vm.title!=''&&_vm.title!='互联网医院'&&_vm.title!='在线问诊历史'&&_vm.isshow==true)?_c('i',{staticClass:"iconfont icon-houtui",on:{"click":_vm.back}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b651dce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/header.vue
// module id = null
// module chunks = 